export default __webpack_public_path__ + "static/couple3-a58f0ab5e14f024169f785606997937a.jpg";